export const HANDLE_CURRENT_CLOUD = "HANDLE_CURRENT_CLOUD";

export const SIDEBAR_DROPDOWN_OPTIONS = "SIDEBAR_DROPDOWN_OPTIONS";
export const SIDEBAR_COLLAPSE_STATE = "SIDEBAR_COLLAPSE_STATE";
export const SIDEBAR_ON_HOVER_CLASSES = "SIDEBAR_ON_HOVER_CLASSES";
export const SAVE_NOTIFI_ARRAY_INFO = "SAVE_NOTIFI_ARRAY_INFO";
